const AboutHero = () => {
  return (
    <>
      <div className="mb-8 flex flex-col items-center justify-center lg:mt-14 lg:flex-row">
        <img
          src="/assets/images/About us Page/rocket-front-color.png"
          alt=""
          className="h-[145px] w-[145px] lg:inline-block"
          // style={{ width: "145px", height: "145px" }}
        />
        <h1 className="text-center font-satoshi-bold lg:-ml-5">
          Transforming education with <br /> community, cohorts and coaches
        </h1>
      </div>
      <div className="mx-10 grid grid-flow-row items-center lg:grid-flow-col">
        <div className="h-full">
          <img src="/assets/images/About us Page/Rectangle 21802@3x.png" alt="" className="mb-5" />
          <img src="/assets/images/About us Page/Rectangle 21743@3x.png" alt="" className="" />
        </div>

        <img
          src="/assets/images/About us Page/1624346912797 1@3x.png"
          alt=""
          className="mb-5 h-4/5 w-full lg:ml-5"
        />
      </div>

      <div className="mx-4 mb-32 grid grid-flow-row lg:mx-10 lg:mt-20 lg:grid-flow-col">
        <div className="font-satoshi-medium text-lg font-semibold leading-8">
          <div className="mb-5 font-satoshi-bold text-[36px] font-black">Vision</div>
          <p className="text-body font-satoshi-medium">
            To be the world’s most student-centric educational institution providing incentive
            aligned education with guaranteed learning outcomes
          </p>
        </div>
        <div className="mt-8 font-satoshi-medium text-lg font-semibold leading-8 lg:ml-20 lg:mt-0">
          <div className="mb-5 font-satoshi-bold text-[36px] font-black">Mission</div>
          <p className="text-body font-satoshi-medium">
            To provide risk free education to students and help them realize their true potential
          </p>
        </div>
      </div>
    </>
  );
};

export default AboutHero;
